import { buttonVariants } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { imageUrl } from '../helpers'

type Props = {
  className?: string
  withLabel?: boolean
  inSidebar?: boolean
  excludeGoogle?: boolean
}

export const LOGIN_BUTTONS_COMPONENT_WIDTH = 257

const LoginButtons = ({
  className,
  withLabel = true,
  excludeGoogle = false,
  inSidebar = false,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        'flex',
        className,
        inSidebar ? 'flex-col w-full gap-2' : 'gap-1 items-center',
      )}
    >
      {withLabel && (
        <span
          className={cn(
            'mr-2 text-sm hidden sm:block',
            inSidebar ? 'text-center' : '',
          )}
        >
          {t('header.log-in-with')}
        </span>
      )}
      <a
        href='/auth/bnet'
        className={cn(buttonVariants({ variant: 'outline' }), 'bg-card-nested')}
      >
        <img src={imageUrl('bnet-logo-blue.svg')} className='w-5 sm:mr-2' />
        <span className='hidden sm:block'>Battle.net</span>
      </a>
      {!excludeGoogle && (
        <a
          href='/auth/google_oauth2'
          className={cn(
            buttonVariants({ variant: 'outline' }),
            'bg-card-nested',
          )}
        >
          <img src={imageUrl('google-logo.svg')} className='w-5 sm:mr-2' />
          <span className='hidden sm:block'>Google</span>
        </a>
      )}
    </div>
  )
}

export default LoginButtons
